// src/components/SafeLink.js

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// Import the custom hook you created
import { useUnsavedChanges } from '../../../context/UnsavedChangesContext';
import { useQueryClient } from '@tanstack/react-query';

const SafeLink = ({ to, children,invalidate=[], ...props }) => {

  // queryclient
  const queryClient = useQueryClient();

  // Get the global state and navigation function
  const { isBlocked } = useUnsavedChanges();
  const navigate = useNavigate();

  const handleClick = (e) => {
    // If we have unsaved changes, intervene!
    if (isBlocked) {
      e.preventDefault(); // Stop the NavLink's default navigation behavior

      // Ask the user for confirmation
      if (window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
        // before navigation invalidate order list, comp list, userlist
        invalidate.forEach((queryKey)=>{
          queryClient.invalidateQueries({queryKey:[queryKey]})
        })

        // If they click "OK", manually navigate to the destination.
        navigate(to);
      }
      // If they click "Cancel", the function ends and nothing happens.
    }
    else{
      invalidate.forEach((queryKey)=>{
        queryClient.invalidateQueries({queryKey:[queryKey]})
      })
    }
  };

  // We use NavLink internally to preserve active class styling
  return (
    <NavLink to={to} onClick={handleClick} {...props}>
      {children}
    </NavLink>
  );
};

export default SafeLink;